import { exhaustiveCaseGuard } from "src/helpers/utils";
import { ExtractPropTypes, PropType } from "vue";
import { RouteLocationRaw } from "vue-router";

import * as iltypes from "src/interfaces/InleagueApiV1"
import authService from "src/helpers/authService";
import { User } from "src/store/User";

export const propsDef = {
  detail: {
    required: true,
    type: Object as PropType<RouteDetail>
  }
} as const;

export type Props = ExtractPropTypes<typeof propsDef>;

export const RouteName = {
  main: "program-registrations-blocked-manager",
} as const;

type RouteName = typeof RouteName;

export type RouteDetail = R_Main

export interface R_Main {
  name: RouteName["main"],
  query?: {
    /**
     * optional; if provided, focus on a single registration rather than some user selected (comp,season,division)
     */
    registrationID?: iltypes.Guid
  }
}

export function routeDetailToRoutePath(detail: RouteDetail) : RouteLocationRaw {
  switch(detail.name) {
    case RouteName.main:
      return {
        name: detail.name,
        query: detail.query ?? undefined
      };
    default:
      exhaustiveCaseGuard(detail.name);
  }
}

export function hasSomeRelevantAccessPermission(allOfTheseCompetitions: "any" | iltypes.Guid[]) : boolean {
  if (!User.userData) {
    return false;
  }

  if (authService(User.userData.roles, "registrar")) {
    return true;
  }

  if (User.userData.divisionsMemento.find(v => v.writeAccess)) {
    return true;
  }

  if (allOfTheseCompetitions === "any") {
    return User.userData.competitionsMemento.some(cm => cm.isPaymentAdmin);
  }
  else {
    return User.userData.competitionsMemento.length > 0 && User.userData.competitionsMemento.every(cm => {
      return cm.isPaymentAdmin && allOfTheseCompetitions.find(competitionUID => cm.competitionUID === competitionUID);
    });
  }
}
